var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 0H1.24609C0.558594 0 0 0.566406 0 1.26172V16.2383C0 16.9336 0.558594 17.5 1.24609 17.5H16.25C16.9375 17.5 17.5 16.9336 17.5 16.2383V1.26172C17.5 0.566406 16.9375 0 16.25 0ZM5.28906 15H2.69531V6.64844H5.29297V15H5.28906ZM3.99219 5.50781C3.16016 5.50781 2.48828 4.83203 2.48828 4.00391C2.48828 3.17578 3.16016 2.5 3.99219 2.5C4.82031 2.5 5.49609 3.17578 5.49609 4.00391C5.49609 4.83594 4.82422 5.50781 3.99219 5.50781ZM15.0117 15H12.418V10.9375C12.418 9.96875 12.3984 8.72266 11.0703 8.72266C9.71875 8.72266 9.51172 9.77734 9.51172 10.8672V15H6.91797V6.64844H9.40625V7.78906H9.44141C9.78906 7.13281 10.6367 6.44141 11.8984 6.44141C14.5234 6.44141 15.0117 8.17188 15.0117 10.4219V15Z",
    fill: "#1D4ED8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.667811e2ae722343c5473e028f953a54.svg";
export { ForwardRef as ReactComponent };